import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  type FilterDraftValue,
  type UniversalBuiltInDrawerFieldConfig,
} from '../../types';

type ToggleDrawerFieldConfig = Extract<
  UniversalBuiltInDrawerFieldConfig,
  { input: 'booleanToggle' | 'toggleGroup' }
>;

type ToggleDrawerFieldControlProps = {
  readonly fieldConfig: ToggleDrawerFieldConfig;
  readonly onChange: (next?: FilterDraftValue) => void;
  readonly testId: string;
  readonly value: string | null;
};

export function ToggleDrawerFieldControl({
  fieldConfig,
  value,
  onChange,
  testId,
}: ToggleDrawerFieldControlProps) {
  const { t } = useTranslation('universalFilters');
  const options =
    fieldConfig.options?.map((option) => ({
      draftValue: option.value,
      label: option.label,
      value: String(option.value),
    })) ??
    (fieldConfig.input === 'booleanToggle'
      ? [
          {
            draftValue: true,
            label: t(($) => $.yes, { ns: 'common' }),
            value: 'true',
          },
          {
            draftValue: false,
            label: t(($) => $.no, { ns: 'common' }),
            value: 'false',
          },
        ]
      : []);
  return (
    <ToggleButtonGroup
      className="bg-white"
      data-testid={testId}
      exclusive
      size="small"
      value={value}
      onChange={(_, next) => {
        const nextOption = options.find((option) => option.value === next);
        onChange(nextOption?.draftValue);
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          className="min-w-16 flex-1"
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
